export default "__VITE_ASSET__C2xz2fJ5__"